import React from 'react'
import DocumentTitle from 'react-document-title'
import config from '../config'
import Link from '../components/Link'
import { getPageTitle } from "../utility/utility"
import './NotFound.scss'

export default class NotFoundPage extends React.Component {
  static pageTitle() {
    return '300 Ashland | Page Not Found';
  }

  render() {
    return (
      <DocumentTitle title={getPageTitle(this.constructor, this.props)}>
        <div className='content not-found' id="main" role="main">
          <h2>Page Not Found</h2>
          <p>We're sorry, the page you were looking for could not be found.</p>
          <p>
            <Link to={config.routerRoot}>Go back home</Link>
          </p>
        </div>
      </DocumentTitle>
    );
  }
}



// WEBPACK FOOTER //
// ./client/pages/NotFound.js